import type { Person } from '../../../eventsApi/persons/person'

export class PartnerEntry {
    partnersEntriesId: string
    partnersPersonsId?: string
    partnerId: string
    createdAt: Date
    paidAt: Date
    availableAt: Date
    updatedAt: Date
    invoiceId?: string
    transactionId?: string
    companyId: string
    description: string
    status: number
    value: number
    type: 'credit' | 'debit'
    comissionPercent: number
    editedAt?: Date
}
